module.exports = __webpack_public_path__ + "files/9afd592d98d9f7c60b653e73326dc9b4.png";